import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Spinner from '../../assets/svgs/Spinner';

const Button = ({ className, children, isLoading = false, ...rest }) => {
    return (
        <button
            type="button"
            className={className}
            disabled={isLoading}
            {...rest}
        >
            {isLoading ? <Spinner /> : children}
        </button>
    );
};

Button.defaultProps = {
    isLoading: false
};

Button.propTypes = {
    className: PropTypes.string.isRequired,
    children: PropTypes.string.isRequired,
    isLoading: PropTypes.bool
};

export default styled(Button)`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 35px;
    border: none;
    font-weight: 300;
    font-size: 1.125em;
    line-height: 1.7em;
    cursor: pointer;
    z-index: 1;
    appearance: none;
    transition: all 450ms;
    border-radius: 7px;
`;
